import { createFileRoute } from '@tanstack/react-router';
import z from 'zod';

import TournamentMatchesModule from '@/modules/fantasy/entity-services/tournament-matches';

export const Route = createFileRoute(
  '/dashboard/fantasy/entity-services/tournament/$competitionId'
)({
  validateSearch: z.object({
    sportType: z.enum(['cricket', 'football']).optional(),
    status: z.enum(['live', 'upcoming', 'completed']).optional(),
    page: z.number().optional(),
    perPage: z.number().optional(),
  }),
  component: TournamentMatchesPage,
});
function TournamentMatchesPage() {
  const { competitionId } = Route.useParams();
  return <TournamentMatchesModule competitionId={competitionId} />;
}
